import { create } from "zustand";
import { persist } from "zustand/middleware";

type Wishlist = {
    listName: string;
    listType: string;
    products: string[];
};

type States = {
    localLists: Wishlist[] | null;
    localListsValid: boolean;
};

type Reducers = {
    updateLocalList: (arg: {
        listName: string;
        listType: string;
        products: string[];
    }) => void;
    validateLocalLists: () => void;
    resetLocalLists: () => void;
};

const initialState: States = {
    localLists: null,
    localListsValid: false,
};

const useLocalWishlistStore = create<States & Reducers>()(
    persist(
        (set, get) => ({
            ...initialState,

            updateLocalList: (arg) => {
                const { listName, listType, products } = arg;
                let currentLists: Wishlist[] = get().localLists || [];

                // Check if list exists
                const existingList = currentLists?.find(
                    (list) => list.listType === listType
                );

                if (existingList) {
                    existingList.products = products;
                } else {
                    const newList = {
                        listName: listName,
                        listType: listType,
                        products,
                    };

                    currentLists = [...currentLists, newList];
                }

                set({ localLists: [...currentLists] });
            },

            validateLocalLists: () => set({ localListsValid: true }),

            resetLocalLists: () => {
                set({ localLists: null, localListsValid: false });
            },
        }),
        {
            name: "wishlist-lists",
        }
    )
);

export default useLocalWishlistStore;

